import { render, staticRenderFns } from "./tabContract.vue?vue&type=template&id=0dd60b63&"
import script from "./tabContract.vue?vue&type=script&lang=js&"
export * from "./tabContract.vue?vue&type=script&lang=js&"
import style0 from "./tabContract.vue?vue&type=style&index=0&id=0dd60b63&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports